import React from 'react'
import styles from './FileImport.module.scss'
interface Props {
    progress: number
}

const FileImportStatusBar: React.FC<Props> = ({ progress }) => {
    return <>{progress > 0 && <progress value={progress} className={styles.statusBar} />}</>
}

export default FileImportStatusBar
